module.exports = __webpack_public_path__ + "img/icon-restaurant-a la carte2.4446d43c.png";